window.pages["productlinerecipes.index"] = {
    init: function () {
        require("../components/load-more-pages");
    },
};
